import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui';

const Login: React.FC = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  
  const { login } = useAuth();
  const { theme, toggleTheme, isDark } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Kullanıcının gelmek istediği sayfa varsa oraya, yoksa ana sayfaya yönlendir
  const from = (location.state as any)?.from?.pathname || '/';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    const success = await login(credentials);
    
    if (success) {
      navigate(from, { replace: true });
    }
    
    setIsLoading(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cafe-cream to-cafe-brown dark:from-dark-bg dark:to-dark-surface transition-all duration-500">
      {/* Theme Toggle - Fixed Position */}
      <div className="fixed top-4 right-4 z-50 flex space-x-2">
        <Button
          variant="secondary"
          size="sm"
          onClick={toggleTheme}
          title={''}
        >
          {isDark ? '☀️' : '🌙'}
        </Button>
      </div>
      
      <div className="max-w-md w-full space-y-6 sm:space-y-8 p-4 sm:p-8 animate-fade-in">
        <div className="bg-white dark:bg-dark-surface rounded-2xl shadow-2xl p-4 sm:p-8 border border-gray-100 dark:border-dark-border transition-all duration-300">
          {/* Logo ve Başlık */}
          <div className="text-center mb-6 sm:mb-8">
            <div className="text-4xl sm:text-6xl mb-3 sm:mb-4 animate-pulse">☕</div>
            <h2 className="text-2xl sm:text-3xl font-bold text-cafe-brown dark:text-cafe-light">
              <span className="hidden sm:inline">GoldCafeT OrderSystem</span>
              <span className="sm:hidden">GoldCafeT</span>
            </h2>
            <p className="text-sm sm:text-base text-gray-600 dark:text-dark-text mt-2">
              Hesabınıza giriş yapın
            </p>
          </div>

          {/* Giriş Formu */}
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div>
              <label htmlFor="username" className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-dark-text mb-1">
                Kullanıcı Adı
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                value={credentials.username}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 dark:border-dark-border rounded-lg bg-white dark:bg-dark-bg text-gray-900 dark:text-dark-text focus:outline-none focus:ring-2 focus:ring-cafe-brown focus:border-transparent transition-all duration-200 text-sm"
                placeholder="Kullanıcı adınızı girin"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-dark-text mb-1">
                Şifre
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={credentials.password}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 dark:border-dark-border rounded-lg bg-white dark:bg-dark-bg text-gray-900 dark:text-dark-text focus:outline-none focus:ring-2 focus:ring-cafe-brown focus:border-transparent transition-all duration-200 text-sm"
                placeholder="Şifrenizi girin"
              />
            </div>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              fullWidth
              disabled={isLoading}
              loading={isLoading}
              className="py-3"
            >
{isLoading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
